import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 0 ${({ theme }): string => theme.spacers!.spacer05};
`;

export const StyledDescription = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.14px;
`;
export const StyledReportDetailsSection = styled.div``;
export const StyledReportDeliverySection = styled.div``;

export const StyledCheckboxGroup = styled.div`
  > div {
    float: unset;
    height: 24px;
  }
`;

export const StyledSideBarFooter = styled.div`
  > div {
    position: unset;
  }
`;

export const StyledBlock = styled.div`
  padding: ${({ theme }): string => theme.spacers!.spacer02} 0;
  display: block;
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer03};
`;

export const StyledUsersBlock = styled(StyledBlock)`
  > div > div:nth-child(2) {
    max-width: 410px;
    max-height: 150px;
  }
`;

export const StyledNameBlock = styled.div`
  .TrekTextField-root {
    margin-bottom: ${({ theme }): string => theme.spacers!.spacer03};
    float: none;
  }
`;

export const StyledDeliveryBlock = styled.div`
  padding: 0 0 ${({ theme }): string => theme.spacers!.spacer03} 30px;
`;

export const StyledDropdownBlock = styled(StyledBlock)`
  padding-left: 30px;
  max-width: 250px;
`;

export const StyledErrorMessage = styled.div`
  color: ${({ theme }): string => theme.admanColors!.red.solid};
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
`;
